import { cn } from '@/lib/utils';

export function MatGridOverlay({ isActive = false, className }: { isActive?: boolean; className?: string }) {
    if (!isActive) return null;

    return (
        <div className={cn("absolute inset-0 overflow-hidden pointer-events-none z-0", className)}>
            <div className="absolute inset-0 opacity-[0.15]">
                {/* SVG Wrestling Mat Wireframe */}
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 min-w-full min-h-[800px]">
                    <defs>
                        <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
                            <path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(212,175,55,0.2)" strokeWidth="1" />
                        </pattern>
                        <radialGradient id="matGlow" cx="50%" cy="50%" r="50%">
                            <stop offset="0%" stopColor="rgba(255,208,0,0.15)" />
                            <stop offset="100%" stopColor="transparent" />
                        </radialGradient>
                    </defs>

                    {/* Grid Background */}
                    <rect width="100%" height="100%" fill="url(#grid)" />

                    {/* Center Highlighting & Rings */}
                    <g className="animate-pulse-glow" style={{ animationDuration: '4s', transformOrigin: 'center', transform: 'scale(1)' }}>
                        {/* Glow Behind Mat */}
                        <circle cx="50%" cy="50%" r="200" fill="url(#matGlow)" />

                        {/* Outer boundary */}
                        <circle cx="50%" cy="50%" r="180" fill="none" stroke="rgba(212,175,55,0.4)" strokeWidth="3" strokeDasharray="8 8" className="animate-angular-spin origin-center" style={{ animationDuration: '40s' }} />

                        {/* Inner wrestling circle */}
                        <circle cx="50%" cy="50%" r="40" fill="none" stroke="rgba(212,175,55,0.6)" strokeWidth="2" />

                        {/* Start lines */}
                        <line x1="10%" y1="50%" x2="40%" y2="50%" stroke="rgba(212,175,55,0.3)" strokeWidth="2" />
                        <line x1="60%" y1="50%" x2="90%" y2="50%" stroke="rgba(212,175,55,0.3)" strokeWidth="2" />

                        <line x1="50%" y1="10%" x2="50%" y2="40%" stroke="rgba(212,175,55,0.3)" strokeWidth="2" />
                        <line x1="50%" y1="60%" x2="50%" y2="90%" stroke="rgba(212,175,55,0.3)" strokeWidth="2" />
                    </g>
                </svg>
            </div>

            {/* Vignette to fade edges into background */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_20%,#0B0D10_80%)]" />
        </div>
    );
}
